import React, { useEffect, useState } from 'react'
import './thinking.css'

// What Bailey is doing while it thinks, so the wait reads as work (Ben, 6 Oct
// 2026: "make sure we really show that it's being smart", like Claude's
// "Combobulating"). A real step from the server ("Checking the diary") always
// wins: it says exactly what's happening. Otherwise a word from this list,
// changing every couple of seconds, in a soft shimmer.
export const THINKING_WORDS = [
  'Thinking',
  'Combobulating',
  'Mulling it over',
  'Joining the dots',
  'Reading the diary',
  'Crunching the numbers',
  'Teasing it out',
  'Weighing it up',
  'Untangling',
  'Brewing ideas',
  'Finding the gaps',
  'Sectioning it off',
  'Blending the options',
  'Doing the maths',
  'Pondering',
  'Putting it together',
  'Seeing the bigger picture',
  'Polishing',
  'Backcombing the details',
  'Getting it just right',
]

// Labels that say nothing about the work itself
export const isGenericActivity = (a) => !a || /^(?:thinking|working on it|writing)\.*…?$/i.test(String(a).trim())

const STEP_MS = 2200

// The word to show now. Starts with "Thinking", then moves round the list
// from a random place, so two waits don't read the same.
export const useThinkingWord = (active = true) => {
  const [i, setI] = useState(0)
  useEffect(() => {
    if (!active) return undefined
    let at = 0
    const start = 1 + Math.floor(Math.random() * (THINKING_WORDS.length - 1))
    const t = setInterval(() => {
      at += 1
      setI(((start + at - 1) % (THINKING_WORDS.length - 1)) + 1)
    }, STEP_MS)
    return () => { clearInterval(t); setI(0) }
  }, [active])
  return THINKING_WORDS[i]
}

// "Combobulating…" (or the real step), shimmering. `activity` is what the
// server said Bailey is doing, if anything.
export const ThinkingWord = ({ activity = null, className = '' }) => {
  const generic = isGenericActivity(activity)
  const word = useThinkingWord(generic)
  const text = generic ? word : String(activity).replace(/[.…]+$/, '')
  return (
    <span className={`bt-think${className ? ` ${className}` : ''}`} role="status" aria-live="polite">
      <span className="bt-think-text" key={text}>{text}…</span>
    </span>
  )
}
